import type { ReactNode } from "react"

/**
 * 신청 폼의 입력 컨트롤 공통 클래스.
 * `<input>` · `<select>` 에 직접 붙여 라벨과 컨트롤의 결합을 느슨하게 둔다.
 */
const FIELD_CONTROL_CLASS = "focus-ring app-field"

interface EntryFormFieldProps {
  /** 감쌀 컨트롤의 id — 라벨과 오류 메시지를 이 값으로 묶는다 */
  controlId: string
  label: string
  isRequired?: boolean
  /** 필수가 아닐 때 라벨 옆에 붙이는 사유 (예: "운영자 확정") */
  optionalHint?: string
  error?: string
  children: ReactNode
}

export default function EntryFormField({
  controlId,
  label,
  isRequired = false,
  optionalHint = "",
  error = "",
  children,
}: Readonly<EntryFormFieldProps>) {
  return (
    <div className="flex flex-col gap-1.5">
      <label
        htmlFor={controlId}
        className="app-label"
      >
        {label}
        {isRequired && (
          <>
            <span
              aria-hidden="true"
              className="text-app-primary-500"
            >
              {" "}
              *
            </span>
            <span className="sr-only"> (필수)</span>
          </>
        )}
        {!isRequired && optionalHint && (
          <span className="app-field-help ml-1 font-medium">
            ({optionalHint})
          </span>
        )}
      </label>

      {children}

      {error && (
        <p
          id={`${controlId}-error`}
          role="alert"
          className="app-field-error"
        >
          {error}
        </p>
      )}
    </div>
  )
}

export { FIELD_CONTROL_CLASS }
export type { EntryFormFieldProps }
